import * as React from "react";
import "./Table.css";
import { filterOrdersByDateRange, makeStyle } from "../../Functions/Functions";
import { ordersRows } from "../../Data/Data";

const MAX_ROWS = 6;

export default function BasicTable({ startDate, endDate }) {

  // Get filtered orders
  const filteredOrders = filterOrdersByDateRange(ordersRows, startDate, endDate);
  const recentOrders = filteredOrders.slice(0, MAX_ROWS);

  return (
    <div className="Table">
      <h3 className="Table-title">Commandes Récentes</h3>
      <table className="Table-recent">
        <thead>
          <tr>
            <th>Commande</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          {recentOrders.map((row) => (
            <tr key={row.commandeId}>
              <td>{row.commandeId}</td>
              <td>
                <span className="Table-pill" style={makeStyle(row.status)}>
                  {row.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
